import React from 'react';
import QueryItemForm from "./QueryItemForm";

function QueryItemTabs(props) {


    // const items = [
    //     {
    //         key: '1',
    //         label: 'Answers',
    //         children: <QueryItemAnswer item={props.item}/>,
    //     },
    //     {
    //         key: '2',
    //         label: 'Config',
    //         children: <QueryItemForm item={props.item} inExtWindow={props.inExtWindow}/>,
    //     },
    // ];

    return (

        <>
            {/*<QueryItemAnswer item={props.item}/>*/}
            <QueryItemForm item={props.item} inExtWindow={props.inExtWindow}/>
            </>
        // <Tabs defaultActiveKey="1" items={items} />
    );
}

export default QueryItemTabs;